import { Link, Navigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { INFO_COPY, type InfoPageKey, resolveUiLanguage } from '../lib/publicCopy';

export default function InfoPage({ page }: { page?: InfoPageKey }) {
  const { i18n } = useTranslation();
  const params = useParams<{ page?: string }>();
  const key = page ?? params.page;
  const copy = INFO_COPY[resolveUiLanguage(i18n.resolvedLanguage ?? i18n.language)];
  if (!key || !(key in copy.pages)) return <Navigate to="/" replace />;
  const data = copy.pages[key as InfoPageKey];

  const ctaTo =
    key === 'technical' ? '/business/pricing' :
    key === 'pricing' ? '/business/model' :
    '/';

  return (
    <main className="min-h-screen bg-[#f7f1e8] px-5 py-8 text-[#211b18] sm:px-8">
      <article className="mx-auto max-w-3xl py-10">
        <Link to="/" className="text-sm text-[#6f625a] hover:text-[#211b18]">← {copy.backHome}</Link>
        <p className="mt-14 font-mono text-xs uppercase tracking-[0.24em] text-[#9b3b36]">{data.kicker}</p>
        <h1 className="mt-4 font-display text-5xl leading-tight sm:text-6xl">{data.title}</h1>
        <div className="mt-8 space-y-5 text-lg leading-relaxed text-[#5f534c]">
          {data.body.map((p) => <p key={p}>{p}</p>)}
        </div>
        <div className="mt-10 flex flex-wrap gap-3 border-t border-[#ded2c8] pt-8">
          <Link to={ctaTo} className="rounded-full bg-[#111] px-6 py-3 text-sm font-semibold text-white">
            {data.cta}
          </Link>
          <Link to="/about/compliance" className="rounded-full border border-[#d1c4b9] px-6 py-3 text-sm font-semibold">
            {copy.complianceLink}
          </Link>
          <Link to="/business/pricing" className="rounded-full border border-[#d1c4b9] px-6 py-3 text-sm font-semibold">
            {copy.pricingLink}
          </Link>
        </div>
      </article>
    </main>
  );
}
